// ─── Relatório SABESP: Inspeção Predial — Teste de Corante ───────────────────
// Layout exato do formulário oficial SABESP
// Usado para os.tipoServico === 'Testes de Corante/Inspeção Ramal'

function fmtDate(ts) {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('pt-BR');
}
function fmtTime(ts) {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}
function v(val) { return (val != null && val !== '') ? String(val) : ''; }

// ── Itens do formulário SABESP ─────────────────────────────────────────────────

const LIGADO = [
  { cod: '01', desc: 'LIGADO por mais de um ramal' },
  { cod: '02', desc: 'LIGADO pela frente' },
  { cod: '03', desc: 'LIGADO pela lateral' },
  { cod: '04', desc: 'LIGADO pelo fundo' },
  { cod: '05', desc: 'LIGADO por autorização de passagem pelo fundo' },
  { cod: '06', desc: 'LIGADO por autorização de passagem pela lateral' },
  { cod: '07', desc: 'LIGADO por ramal coletivo' },
  { cod: '', desc: 'Águas Pluviais conectado ao esgoto' },
  
];

// Seção 2: coluna esquerda (21–28) e direita (29–42)
const FACTIVEL_L = [
  { cod: '21', desc: 'FACTÍVEL pela frente – esgotando em fossa' },
  { cod: '22', desc: 'FACTÍVEL pela lateral – esgotando em fossa' },
  { cod: '23', desc: 'FACTÍVEL pelo fundo – esgotando em fossa' },
  { cod: '24', desc: 'FACTÍVEL pela frente – esgotando em rede particular' },
  { cod: '25', desc: 'FACTÍVEL pelo fundo – esgotando em rede particular' },
  { cod: '26', desc: 'FACTÍVEL pela lateral – esgotando em rede particular' },
  { cod: '27', desc: 'FACTÍVEL pela frente – esgotando em córrego / GAP / céu aberto' },
  { cod: '28', desc: 'FACTÍVEL pela lateral – esgotando em córrego / GAP / céu aberto' },
];

const FACTIVEL_R = [
  { cod: '29', desc: 'FACTÍVEL pelo fundo – esgotando em córrego / GAP / céu aberto' },
  { cod: '33', desc: 'FACTÍVEL – autorização de passagem pela lateral - esgotando em fossa' },
  { cod: '34', desc: 'FACTÍVEL – autorização de passagem pela lateral - esgotando em rede particular' },
  { cod: '35', desc: 'FACTÍVEL – autorização de passagem pela lateral - esgotando em córrego / GAP / céu aberto' },
  { cod: '36', desc: 'FACTÍVEL – autorização de passagem pelo fundo - esgotando em fossa' },
  { cod: '37', desc: 'FACTÍVEL – autorização de passagem pelo fundo - esgotando em rede particular' },
  { cod: '38', desc: 'FACTÍVEL – autorização de passagem pelo fundo - esgotando em córrego / GAP / céu aberto' },
  { cod: '42', desc: 'FACTÍVEL – imóvel em construção' },
];

// Seção 3 esquerda
const BOMBEAMENTO = [
  { cod: '61', desc: 'FACTÍVEL por bombeamento – esgotando em fossa' },
  { cod: '62', desc: 'FACTÍVEL por bombeamento – esgotando em rede particular' },
  { cod: '63', desc: 'FACTÍVEL por bombeamento – esgotando em córrego / GAP / céu aberto' },
  { cod: '67', desc: 'FACTÍVEL por bombeamento – sistema de esgotamento e tratamento particular' },
  { cod: '69', desc: 'FACTÍVEL por bombeamento – ligação subnormal' },
];

// Seção 3 direita
const POTENCIAL = [
  { cod: '51', desc: 'POTENCIAL – esgotando em fossa' },
  { cod: '52', desc: 'POTENCIAL – esgotando em rede particular' },
  { cod: '53', desc: 'POTENCIAL – esgotando em córrego / GAP / céu aberto' },
  { cod: '54', desc: 'POTENCIAL – sistema de esgotamento e tratamento particular' },
  { cod: '55', desc: 'POTENCIAL – habitação subnormal' },
];

// Seção 4 — mapeamento campo → rótulo (9 itens em 2 colunas)
const INFO_ADICIONAIS = [
  ['estudoProlongamento',       'Necessário Estudo de Prolongamento de RCE'],
  ['estudoProfundidadeSoleira', 'Necessário Estudo de Profundidade de Soleira'],
  ['imovelFechado',             'Imóvel fechado / Morador ausente'],
  ['clienteNaoAutorizou',       'Cliente não autorizou a entrada no imóvel'],
  ['pvObstruido',               'Poço de visita coberto'],
  ['redeObstruida',             'Rede ou caixa de inspeção (cliente) obstuída'],
  ['clienteConectadoRamal',     'Cliente conectado através de ramal coletivo'],
  ['clienteDesejaLigacao',      'Cliente deseja ligação / disponibilização de ramal'],
  ['pdeJaCadastrado',           'PDE já cadastrado com TL1'],
  ['imovelNaoLocalizado',       'IMÓVEL NÃO LOCALIZADO'],
];

const CATEGORIAS = ['Residência', 'Comércio', 'Indústria', 'Pública', 'Mista'];

// ─────────────────────────────────────────────────────────────────────────────
export function gerarRelatorioCoranteSabesp(
  os,
  tecnicoNome,
  logoUrl,
  { STATUS_LABELS, CHECKLIST_PADRAO, contrato } = {},
  empresa = 'pg',
) {
  const de  = os.dadosEspecificos || {};
  const formaEsgotamento = Array.isArray(de.formaEsgotamento) ? de.formaEsgotamento : [];
  const isSelected = (cod) => formaEsgotamento.includes(cod);

  // ── Helpers de checkbox / radio ────────────────────────────────────────────
  const chkOn  = '<span class="chk on">&#10004;</span>';
  const chkOff = '<span class="chk off"></span>';
  const radOn  = '<span class="rad on">&#9679;</span>';
  const radOff = '<span class="rad off"></span>';

  // Gera linhas em 2 colunas intercalando array esquerdo e direito
  function dualRows(left, right) {
    const n = Math.max(left.length, right.length);
    return Array.from({ length: n }, (_, i) => {
      const l = left[i];
      const r = right[i];
      const lOn = l ? isSelected(l.cod) : false;
      const rOn = r ? isSelected(r.cod) : false;
      return `<tr>
        <td class="c-cod">${l ? l.cod : ''}</td>
        <td class="c-chk">${l ? (lOn ? chkOn : chkOff) : ''}</td>
        <td class="c-desc${lOn ? ' sel' : ''}">${l ? l.desc : ''}</td>
        <td class="col-sep"></td>
        <td class="c-cod">${r ? r.cod : ''}</td>
        <td class="c-chk">${r ? (rOn ? chkOn : chkOff) : ''}</td>
        <td class="c-desc${rOn ? ' sel' : ''}">${r ? r.desc : ''}</td>
      </tr>`;
    }).join('');
  }

  // Gera linhas de uma única coluna
  function singleRows(items) {
    return items.map(item => {
      const on = isSelected(item.cod);
      return `<tr>
        <td class="c-cod">${item.cod}</td>
        <td class="c-chk">${on ? chkOn : chkOff}</td>
        <td class="c-desc${on ? ' sel' : ''}">${item.desc}</td>
      </tr>`;
    }).join('');
  }

  // ── Categoria de uso ───────────────────────────────────────────────────────
  const catHtml = CATEGORIAS.map(cat => {
    const on = de.categoriaUso === cat;
    return `${on ? radOn : radOff}&thinsp;<span class="${on ? 'lbl-sel' : ''}">${cat}</span>`;
  }).join('&nbsp;&nbsp;');

  // ── Proprietário ───────────────────────────────────────────────────────────
  const propSim = de.proprietario === 'Sim' || de.proprietario === true;
  const propNao = de.proprietario === 'Não' || de.proprietario === false;

  // ── Data / Hora / Placa ────────────────────────────────────────────────────
  const dataVisita = fmtDate(os.criadaEm)  || fmtDate(os.atualizadaEm) || '';
  const horaVisita = fmtTime(os.criadaEm)  || v(os.hora)                || '';
  const placa      = v(de.placaVeiculo)    || v(os.placa)               || '';

  // ── Informações adicionais — 2 colunas (primeira metade esq, segunda dir) ─
  const infoMid = Math.ceil(INFO_ADICIONAIS.length / 2);
  const infoL = INFO_ADICIONAIS.slice(0, infoMid);
  const infoR = INFO_ADICIONAIS.slice(infoMid);
  const infoRows = Array.from({ length: Math.max(infoL.length, infoR.length) }, (_, i) => {
    const l   = infoL[i];
    const r   = infoR[i];
    const lOn = l ? Boolean(de[l[0]]) : false;
    const rOn = r ? Boolean(de[r[0]]) : false;
    return `<tr>
      <td class="c-chk">${l ? (lOn ? chkOn : chkOff) : ''}</td>
      <td class="info-desc${lOn ? ' sel' : ''}">${l ? l[1] : ''}</td>
      <td class="info-sep"></td>
      <td class="c-chk">${r ? (rOn ? chkOn : chkOff) : ''}</td>
      <td class="info-desc${rOn ? ' sel' : ''}">${r ? r[1] : ''}</td>
    </tr>`;
  }).join('');

  // ── Fotos ──────────────────────────────────────────────────────────────────
  const fotos = (de.fotos || os.fotos || []).filter(f => f && f.url);

  // Agrupar fotos em linhas de 3
  const fotoRows = [];
  for (let i = 0; i < fotos.length; i += 3) fotoRows.push(fotos.slice(i, i + 3));

  const fotoPage = fotos.length === 0 ? '' : `
  <div class="foto-page">
    <div class="sec-header">Registros Fotográficos &mdash; OS ${v(os.numeroOS)} (${fotos.length} foto${fotos.length !== 1 ? 's' : ''})</div>
    <table class="foto-tbl">
      ${fotoRows.map((row, ri) => `
      <tr>
        ${row.map((f, ci) => `
        <td class="foto-cell">
          <img src="${f.url}" class="foto-img" alt="Foto ${ri * 3 + ci + 1}"/>
          <div class="foto-leg">${f.legenda || ('Foto ' + (ri * 3 + ci + 1))}</div>
        </td>`).join('')}
        ${row.length < 3 ? `<td class="foto-cell"></td>`.repeat(3 - row.length) : ''}
      </tr>`).join('')}
    </table>
  </div>`;

  // ── Assinatura do cliente ──────────────────────────────────────────────────
  const assinHtml = de.clienteRecusouAssinar
    ? `<div class="assin-refused">CLIENTE RECUSOU ASSINAR</div>`
    : de.assinaturaCliente
      ? `<img src="${de.assinaturaCliente}" class="assin-img" alt="Assinatura do cliente"/>`
      : '<div class="assin-blank"></div>';

  // ══════════════════════════════════════════════════════════════════════════
  // CSS
  // ══════════════════════════════════════════════════════════════════════════
  const css = `
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, Helvetica, sans-serif; font-size: 9pt; color: #000; background: #f0f0f0; }
    .page-wrap { max-width: 210mm; margin: 10px auto; background: #fff; }

    /* ── Wrapper com borda externa ── */
    .form-wrapper { border: 1.5px solid #000; background: #fff; }

    /* ── Cabeçalho ── */
    .hdr-tbl { width: 100%; border-collapse: collapse; }
    .hdr-logo {
      width: 90px; padding: 6px 8px;
      border-right: 1px solid #000; vertical-align: middle; text-align: center;
    }
    .hdr-logo img { max-width: 72px; max-height: 50px; object-fit: contain; display: block; margin: 0 auto; }
    .hdr-sabesp { font-size: 8.5pt; font-weight: bold; color: #0093dd; text-align: center; margin-top: 4px; letter-spacing: 0.04em; }
    .hdr-title { padding: 5px 10px; vertical-align: middle; border-right: 1px solid #000; }
    .hdr-title .company { font-size: 9.5pt; font-weight: bold; color: #1a3a6e; line-height: 1.2; }
    .hdr-title .form-t  { font-size: 9pt; font-weight: bold; margin-top: 3px; }
    .hdr-os { width: 145px; padding: 0; vertical-align: top; }
    .os-row { border-bottom: 1px solid #000; padding: 3px 6px; min-height: 26px; }
    .os-row:last-child { border-bottom: none; }
    .os-lbl { font-size: 7pt; color: #555; display: block; }
    .os-val { font-size: 9pt; font-weight: bold; display: block; min-height: 13px; }

    /* ── Linha Endereço / PDE (2ª linha do cabeçalho) ── */
    .hdr-addr-row { padding: 3px 5px; border-top: 1px solid #000; vertical-align: top; }
    .hdr-pde { width: 145px; padding: 3px 6px; border-left: 1px solid #000; border-top: 1px solid #000; vertical-align: top; }

    /* ── Linhas de campo ── */
    .fields-tbl { width: 100%; border-collapse: collapse; border-top: 1px solid #000; }
    .fields-tbl td { border-right: 1px solid #000; padding: 3px 5px; vertical-align: top; }
    .fields-tbl td:last-child { border-right: none; }
    .fl { font-size: 6.5pt; color: #555; display: block; }
    .fv { font-size: 9pt; font-weight: 500; display: block; min-height: 14px; }

    /* ── Checkboxes / radio ── */
    .chk {
      display: inline-block; width: 12px; height: 12px; border: 1px solid #000;
      text-align: center; line-height: 11px; font-size: 9pt; vertical-align: middle;
    }
    .chk.on  { background: #000; color: #fff; font-size: 8pt; font-weight: bold; }
    .chk.off { background: #fff; }
    .rad {
      display: inline-block; width: 12px; height: 12px; border: 1px solid #000;
      border-radius: 50%; text-align: center; line-height: 10px; font-size: 7pt; vertical-align: middle;
    }
    .rad.on  { background: #000; color: #fff; }
    .rad.off { background: #fff; }
    .lbl-sel { font-weight: bold; }

    /* ── Cabeçalhos de seção ── */
    .sec-header {
      background: #1B254B; color: #fff; font-size: 8pt; font-weight: bold;
      text-align: center; padding: 4px 8px; border-top: 1px solid #000;
      text-transform: uppercase; letter-spacing: 0.04em;
      -webkit-print-color-adjust: exact; print-color-adjust: exact;
    }

    /* ── Tabela de itens (seções 1 e 2) ── */
    .items-tbl { width: 100%; border-collapse: collapse; }
    .items-tbl td { border-bottom: 1px solid #e0e0e0; padding: 2px 3px; vertical-align: middle; }
    .items-tbl tr:last-child td { border-bottom: none; }
    .c-cod { width: 22px; text-align: center; font-weight: bold; font-size: 7pt; color: #444; border-right: 1px solid #d0d0d0; }
    .c-chk { width: 16px; text-align: center; border-right: 1px solid #d0d0d0; }
    .c-desc { font-size: 7.5pt; line-height: 1.3; padding-left: 3px; }
    .c-desc.sel { font-weight: bold; }
    /* separador central entre as 2 colunas */
    .col-sep { width: 3px; background: #ccc; border-left: 1px solid #aaa; border-right: 1px solid #aaa; padding: 0; }

    /* ── Obs ── */
    .obs-box {
      font-size: 6.5pt; color: #333; padding: 3px 6px;
      border-top: 1px solid #000; line-height: 1.35; background: #fafafa;
    }
    .obs-box strong { font-weight: bold; }

    /* ── Seção 3: split bombeamento | potencial ── */
    .split-tbl { width: 100%; border-collapse: collapse; border-top: 1px solid #000; }
    .split-l { width: 50%; vertical-align: top; border-right: 1.5px solid #000; }
    .split-r { width: 50%; vertical-align: top; }
    .split-header {
      background: #2d4a7a; color: #fff; font-size: 7.5pt; font-weight: bold;
      text-align: center; padding: 3px 4px; text-transform: uppercase; letter-spacing: 0.03em;
      -webkit-print-color-adjust: exact; print-color-adjust: exact;
    }

    /* ── Informações adicionais ── */
    .info-tbl { width: 100%; border-collapse: collapse; }
    .info-tbl td { padding: 2px 4px; font-size: 7.5pt; vertical-align: middle; }
    .info-tbl tr { border-bottom: 1px solid #ececec; }
    .info-tbl tr:last-child { border-bottom: none; }
    .info-desc { line-height: 1.3; }
    .info-desc.sel { font-weight: bold; }
    .info-sep { width: 6px; background: #e8e8e8; border-left: 1px solid #bbb; border-right: 1px solid #bbb; }

    /* ── Rodapé (data / hora / placa) ── */
    .foot-tbl { width: 100%; border-collapse: collapse; border-top: 1px solid #000; }
    .foot-tbl td { border-right: 1px solid #000; padding: 3px 6px; vertical-align: top; }
    .foot-tbl td:last-child { border-right: none; }

    /* ── Assinatura ── */
    .sign-area { border-top: 1px solid #000; padding: 4px 8px 2px; min-height: 64px; }
    .sign-lbl  { font-size: 7pt; color: #333; font-weight: bold; margin-bottom: 2px; }
    .assin-img   { max-width: 240px; max-height: 72px; object-fit: contain; display: block; }
    .assin-blank { min-height: 52px; }
    .assin-refused {
      border: 1.5px solid #c00; color: #c00; font-weight: bold; font-size: 9pt;
      text-align: center; padding: 10px 8px; border-radius: 4px; background: #fff5f5;
      -webkit-print-color-adjust: exact; print-color-adjust: exact;
    }
    .sign-row-tbl { width: 100%; border-collapse: collapse; border-top: 1px solid #000; }
    .sign-row-tbl td { border-right: 1px solid #000; padding: 4px 8px; vertical-align: bottom; width: 50%; }
    .sign-row-tbl td:last-child { border-right: none; }
    .sign-line { border-top: 1px solid #555; margin-top: 28px; margin-bottom: 2px; }
    .sign-name { font-size: 8.5pt; font-weight: bold; margin-top: 3px; }

    /* ── Fotos (página 2) ── */
    .foto-page { page-break-before: always; border: 1.5px solid #000; margin-top: 10px; width: 100%; box-sizing: border-box; }
    .foto-tbl  { width: 100%; border-collapse: collapse; table-layout: fixed; padding: 4px; }
    .foto-cell { width: 33.33%; padding: 4px; text-align: center; vertical-align: top; }
    .foto-img  { width: 100%; height: 185px; object-fit: cover; border: 1px solid #ccc; display: block; }
    .foto-leg  { font-size: 7.5pt; color: #555; margin-top: 3px; }

    /* ── Botão de impressão ── */
    .print-actions { text-align: center; padding: 16px 0 40px; }
    .print-actions button {
      padding: 10px 36px; background: #1B254B; color: #fff; border: none;
      border-radius: 8px; cursor: pointer; font-size: 14px; font-weight: 700;
      font-family: Arial, sans-serif;
    }

    @page { size: A4; margin: 8mm; }
    @media print {
      body { background: #fff; }
      .page-wrap { margin: 0; }
      .print-actions { display: none !important; }
      .foto-img { height: 165px; }
    }
  `;

  // ══════════════════════════════════════════════════════════════════════════
  // HTML
  // ══════════════════════════════════════════════════════════════════════════
  const html = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="UTF-8"/>
  <title>Relatório Corante SABESP — OS ${v(os.numeroOS)}</title>
  <style>${css}</style>
</head>
<body>
<div class="page-wrap">
<div class="form-wrapper">

  <!-- ════ CABEÇALHO ════ -->
  <table class="hdr-tbl">
    <!-- Linha 1: Logo (rowspan 2) | Título empresa | Ordem de Serviço + Fornecimento -->
    <tr>
      <td class="hdr-logo" rowspan="2">
        <img src="${logoUrl}" alt="SABESP"/>
        <div class="hdr-sabesp">sabesp</div>
      </td>
      <td class="hdr-title">
        <div class="company">Companhia de Saneamento Básico do Estado de São Paulo</div>
        <div class="form-t">Relatório de Inspeção Predial &ndash; Teste de Corante</div>
      </td>
      <td class="hdr-os">
        <div class="os-row">
          <span class="os-lbl">Ordem de Serviço:</span>
          <span class="os-val">${v(os.numeroOS)}</span>
        </div>
        <div class="os-row">
          <span class="os-lbl">Fornecimento</span>
          <span class="os-val">${v(de.rgi)}</span>
        </div>
      </td>
    </tr>
    <!-- Linha 2: (logo continua) | Endereço | PDE -->
    <tr>
      <td class="hdr-addr-row">
        <span class="fl">Endereço:</span>
        <span class="fv">${v(de.enderecoImovel || os.logradouro)}</span>
      </td>
      <td class="hdr-pde">
        <span class="os-lbl">PDE</span>
        <span class="os-val">${v(de.tl)}</span>
      </td>
    </tr>
  </table>

  <!-- ════ CODIFICAÇÃO / HIDRÔMETRO / LEITURA / MORADORES ════ -->
  <table class="fields-tbl">
    <tr>
      <td>
        <span class="fl">Codificação</span>
        <span class="fv">${v(de.codificacao)}</span>
      </td>
      <td style="width:130px">
        <span class="fl">Hidrômetro</span>
        <span class="fv">${v(de.hidrometro)}</span>
      </td>
      <td style="width:110px">
        <span class="fl">Leitura (m³)</span>
        <span class="fv">${v(de.leitura)}</span>
      </td>
      <td style="width:100px">
        <span class="fl">Moradores</span>
        <span class="fv">${v(de.moradores)}</span>
      </td>
    </tr>
  </table>

  <!-- ════ DADOS DO IMÓVEL — linha 2 ════ -->
  <table class="fields-tbl">
    <tr>
      <td>
        <span class="fl">Categoria de Uso do Imóvel / Ramo de Atividade / Quantidade de Economias</span>
        <div style="margin-top:3px;font-size:8.5pt;">${catHtml}</div>
      </td>
      <td style="width:140px;">
        <span class="fl">Proprietário</span>
        <div style="margin-top:3px;font-size:8.5pt;">
          ${propSim ? radOn : radOff}&thinsp;<span class="${propSim ? 'lbl-sel' : ''}">Sim</span>
          &nbsp;&nbsp;
          ${propNao ? radOn : radOff}&thinsp;<span class="${propNao ? 'lbl-sel' : ''}">Não</span>
        </div>
      </td>
    </tr>
  </table>

  <!-- ════ DADOS DO IMÓVEL — linha 3 ════ -->
  <table class="fields-tbl">
    <tr>
      <td>
        <span class="fl">Nome do cliente</span>
        <span class="fv">${v(de.nomeCliente)}</span>
      </td>
      <td style="width:145px;">
        <span class="fl">RG / CPF</span>
        <span class="fv">${v(de.rg)}</span>
      </td>
      <td style="width:120px;">
        <span class="fl">Telefone</span>
        <span class="fv">${v(de.telefone)}</span>
      </td>
    </tr>
  </table>

  <!-- ════ SEÇÃO 1: LIGADO NA RCE ════ -->
  <div class="sec-header">
    Imóvel Ligado na Rede Coletora de Esgoto (RCE) da SABESP
  </div>
  <table class="items-tbl">
    ${dualRows(LIGADO.slice(0, 4), LIGADO.slice(4))}
  </table>
  <div class="obs-box">
    <strong>Obs.:</strong> Quando constatado que o imóvel se encontra ligado à RCE, os serviços de
    coleta e/ou afastamento dos esgotos serão tarifados mensalmente, tendo por referência o consumo
    de água, nos termos do Artigo 5º do Decreto Estadual nº 41.446/96.
  </div>

  <!-- ════ SEÇÃO 2: FACTÍVEL ════ -->
  <div class="sec-header">
    Imóvel Factível de Ligação &ndash; Não Ligado à Rede Coletora
  </div>
  <table class="items-tbl">
    ${dualRows(FACTIVEL_L, FACTIVEL_R)}
  </table>
  <div class="obs-box">
    <strong>Obs.:</strong> Quando factível, recomendamos a execução e notificação da ligação
    predial (modelo anexo) em <strong>ATÉ 30 DIAS</strong>. Após a montagem, solicite a sua
    ligação de esgotos pelo telefone <strong>0800-0550195</strong>. Esgotado o prazo acima e
    não havendo manifestação por parte de V. Sº, os dados do seu imóvel serão remetidos à
    Prefeitura Municipal, conforme exigências legais aplicáveis sobre a obrigatoriedade de
    conexão à Rede Coletora existente no logradouro. Segundo a Lei Federal de Saneamento
    Básico (11.445/07, Art. 45). <strong>A conexão à rede de esgoto é obrigatória.</strong>
  </div>

  <!-- ════ SEÇÃO 3: BOMBEAMENTO | POTENCIAL ════ -->
  <table class="split-tbl">
    <tr>
      <td class="split-l">
        <div class="split-header">Imóvel Factível por Bombeamento</div>
        <table class="items-tbl">
          ${singleRows(BOMBEAMENTO)}
        </table>
      </td>
      <td class="split-r">
        <div class="split-header">Potencial &ndash; Necessário à Implantação de Rede</div>
        <table class="items-tbl">
          ${singleRows(POTENCIAL)}
        </table>
      </td>
    </tr>
  </table>
  <div class="obs-box">
    <strong>Obs.:</strong> Destacamos que, nos termos do art. 45 da Lei Federal nº 11.445/2007,
    todas as edificações permanentes urbanas, novas ou existentes, devem ser conectadas às redes
    públicas de esgotamento sanitário quando estas estiverem disponíveis. A obrigatoriedade de
    conexão permanece válida mesmo que a edificação ainda não esteja interligada, estando o
    usuário sujeito à cobrança da tarifa mínima. Adicionalmente, conforme o art. 42 da
    Deliberação ARESP nº 106/2009, quando a rede pública estiver em nível superior às
    instalações de utilidade usuária, o usuário será responsável pela construção, operação e
    manutenção dos equipamentos necessários à elevação do esgoto, garantindo sua posterior
    captação pelo prestador do serviço.
  </div>

  <!-- ════ SEÇÃO 4: INFORMAÇÕES ADICIONAIS ════ -->
  <div class="sec-header">Informações Adicionais</div>
  <table class="info-tbl">
    ${infoRows}
  </table>

  <!-- ════ RODAPÉ: Data / Hora / Placa ════ -->
  <table class="foot-tbl">
    <tr>
      <td style="width:30%;">
        <span class="fl">Data</span>
        <span class="fv">${dataVisita}</span>
      </td>
      <td style="width:35%;">
        <span class="fl">Hora da Visita</span>
        <span class="fv">${horaVisita}</span>
      </td>
      <td>
        <span class="fl">Placa do Veículo</span>
        <span class="fv">${placa}</span>
      </td>
    </tr>
  </table>

  <!-- ════ ASSINATURA DO CLIENTE ════ -->
  <div class="sign-area">
    <div class="sign-lbl">Assinatura do cliente (Recibo capital da/ao/do bem):</div>
    ${assinHtml}
  </div>

  <!-- ════ ASSINATURA DO TÉCNICO ════ -->
  <table class="sign-row-tbl">
    <tr>
      <td>
        <div class="sign-line"></div>
        <div style="font-size:6.5pt;color:#555;text-align:center;">Assinatura do responsável pelo imóvel</div>
      </td>
      <td>
        <div style="font-size:7pt;color:#555;font-weight:normal;margin-bottom:3px;">Técnico responsável:</div>
        <div class="sign-name">${tecnicoNome || ''}</div>
      </td>
    </tr>
  </table>

</div><!-- /form-wrapper -->

${fotoPage}
</div><!-- /page-wrap -->

<div class="print-actions">
  <button onclick="window.print()">🖨️ Imprimir / Salvar PDF</button>
</div>
</body>
</html>`;

  return html;
}
